import React from "react";
import styled from "styled-components";

const Container = styled.div`
  z-index: 1;
  padding-left: 24px;
  max-width: 70%;
`;

export const PrivacyPolicyIt = (): React.ReactElement => {
  return (
    <Container>
      <h2>Aste Online del PAM</h2>
      <h3>Informativa sulla Privacy</h3>
      <p>
        La presente Informativa sulla Privacy regola la raccolta, l'utilizzo e
        la divulgazione delle informazioni personali da parte delle Aste Online
        del PAM, un Servizio Globale Condiviso gestito dal Programma Alimentare
        Mondiale ("PAM"), che offre a organizzazioni delle Nazioni Unite, ONG,
        enti governativi, e soggetti attivi nei settori umanitario e dello
        sviluppo, la possibilità di partecipare ad aste.
      </p>

      <h3>Introduzione</h3>
      <p>
        Le Aste Online del PAM si impegnano a proteggere la privacy e la
        riservatezza delle informazioni personali dei propri utenti. Questa
        informativa descrive come vengono raccolte, utilizzate e tutelate le
        informazioni fornite dagli utenti durante l'accesso e l'utilizzo
        dell'applicazione mobile delle Aste Online del PAM.
      </p>

      <h3>Raccolta e Utilizzo delle Informazioni Personali</h3>
      <p>
        Le Aste Online del PAM possono raccogliere dagli utenti alcune
        informazioni personali identificabili (IPI) al fine di facilitare il
        processo di offerta. Queste informazioni vengono utilizzate
        esclusivamente per lo scopo specifico della partecipazione all'asta. La
        raccolta delle IPI è necessaria per garantire una prestazione efficiente
        dei servizi e per adempiere agli obblighi impliciti. Le Aste Online del
        PAM non prevedono l’utilizzo delle IPI per nessun altro scopo.
      </p>

      <h3>Informazioni Non Personali Identificabili</h3>
      <p>
        Accedendo alle Aste Online del PAM, alcune informazioni come gli
        indirizzi di protocollo Internet (IP), la navigazione all'interno della
        piattaforma, il tipo di browser utilizzato, il tempo trascorso e altre
        informazioni simili verranno memorizzate sui nostri server e su un
        software di analisi di terze parti. Queste informazioni vengono trattate
        in modo confidenziale. Lo scopo della raccolta di dati non personali è
        analizzare le preferenze dei visitatori delle Aste Online del PAM, al
        fine di ottimizzare il servizio e migliorare la loro esperienza d’uso.
        Queste informazioni non vengono mai collegate ai dati personali forniti
        dagli utenti.
      </p>

      <h3>Misure di Sicurezza</h3>
      <p>
        Le Aste Online del PAM adottano misure di sicurezza adeguate per
        proteggere la riservatezza e l'integrità delle informazioni personali
        degli utenti. Queste misure includono la crittografia, l'archiviazione
        sicura dei dati e l'accesso limitato ai dati personali.
      </p>

      <h3>Richiesta di Cancellazione dei Dati</h3>
      <p>
        Gli utenti possono richiedere la cancellazione dei propri dati personali
        contattando l’indirizzo email support.auctiondigitaloffice@wfp.org,
        spiegando il motivo della richiesta. Questo messaggio darà avvio al
        processo di cancellazione dei dati. Si prega di notare che alcuni dati
        potrebbero essere conservati per un periodo limitato, come richiesto
        dalle leggi o normative applicabili.
      </p>

      <h3>Divulgazione a Terze Parti</h3>
      <p>
        Le Aste Online del PAM non divulgano informazioni personali a terze
        parti, ad eccezione dei casi in cui ciò sia necessario per facilitare i
        servizi richiesti o come previsto dalla legge o da procedimenti legali.
      </p>

      <h3>Modifiche all’Informativa sulla Privacy</h3>
      <p>
        Le Aste Online del PAM possono aggiornare periodicamente la presente
        Informativa sulla Privacy. Si consiglia di consultarla regolarmente per
        rimanere informati su come vengono protette le informazioni personali.
      </p>

      <h3>Risoluzione delle Controversie</h3>
      <p>
        Qualsiasi disputa, controversia o reclamo derivante da o relativo alla
        presente Informativa sulla Privacy sarà risolta tramite arbitrato, in
        conformità con le Regole Arbitrali UNCITRAL allora in vigore. Il
        tribunale arbitrale non avrà l'autorità di assegnare danni punitivi. Il
        PAM e l’Utente saranno vincolati da qualsiasi decisione arbitrale
        emessa, che costituirà la risoluzione definitiva e vincolante di ogni
        eventuale controversia. La lingua utilizzata in tali procedimenti sarà
        l’inglese.
      </p>

      <h3>Privilegi e Immunità</h3>
      <p>
        Nulla in questa Informativa sulla Privacy, né in relazione a questo
        Servizio, potrà essere interpretato come una rinuncia a qualsiasi
        privilegio o immunità del PAM ai sensi della Convenzione sui Privilegi e
        le Immunità delle Nazioni Unite e della Convenzione sui Privilegi e le
        Immunità delle Agenzie Specializzate.
      </p>

      <h3>Contatti</h3>
      <p>
        Per qualsiasi domanda o dubbio riguardante questa Informativa sulla
        Privacy o il trattamento di dati personali, si e’ pregati di contattare
        l’indirizzo support.auctiondigitaloffice@wfp.org.
      </p>
    </Container>
  );
};
